<template>
  <div class="dimensions-container">
    <div class="description-box">
      {{ texts.description }}
    </div>
    <div class="dimensions section">
      <div class="title">
        {{ texts.dimension.title }}
        <div class="subtitle">
          {{ texts.dimension.subtitle }}
        </div>
      </div>
      <DimensionDropdown
        :selectedDimension="selectedDimension"
        :includeFullSegments="includeFullSegments"
        :availableShopperIntelligenceSegments="availableShopperIntelligenceSegments"
        :isAllSegmentsInactive="isAllSegmentsInactive"
        @input="$emit('setDimension', $event)"
        @includeFullSegments="$emit('handleIncludeFullSegments', $event)"
      />
    </div>
    <div class="metrics section">
      <div class="title">
        {{ texts.metrics.title }}
        <div class="subtitle">
          {{ texts.metrics.subtitle }}
        </div>
      </div>
      <MetricsCheckList
        v-model="metricsList"
        @updateMetrics="$emit('updateMetrics')"
      />
    </div>
  </div>
</template>
<script>
import DimensionDropdown from './DimensionDropdown';
import MetricsCheckList from './MetricsCheckList.vue';

export default {
  props: {
    selectedDimension: {
      type: String,
      default: '',
    },
    includeFullSegments: {
      type: Boolean,
      default: false,
    },
    metricsList: {
      type: Array,
    },
    availableShopperIntelligenceSegments: {
      type: Array,
      required: true,
    },
    isAllSegmentsInactive: {
      type: Boolean,
    },
  },
  data() {
    return {
      texts: {
        description: 'Configure your report to change your dimension, ' +
          'metrics or apply filters. You can drag and drop the metrics to ' +
          'the right to change the order they appear in your report.',
        dimension: {
          title: 'Select dimension',
          subtitle: 'You can only select one dimension for demographic reports',
        },
        metrics: {
          title: 'Select metrics',
          subtitle: 'All metrics shown in Shopper Intelligence reports ' +
            'are based on consumers matched to external datasets. '  +
            'For this reason, you may notice differences in reported numbers ' +
            'here compared to other areas of MikMak Insights.',
        },
      },
    };
  },
  components: {
    DimensionDropdown,
    MetricsCheckList,
  },
};
</script>
<style scoped>
.description-box {
  padding: 12px;
  width: calc(100% - 24);
  top: 100px;
  margin-bottom: 24px;
  background: #F0F3FE;
  border-radius: 4px;
}
.section {
  padding-bottom: 24px;
}
.title {
  font-weight: bold;
  font-size: 18px;
  line-height: 140%;
  color: #223448;
}
.subtitle {
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  color: #778699;
}
</style>
